import { render, staticRenderFns } from "./education.table.vue?vue&type=template&id=0ddcbd63&scoped=true&"
import script from "./education.table.vue?vue&type=script&lang=js&"
export * from "./education.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddcbd63",
  null
  
)

export default component.exports